import axios from "axios";
const token = JSON.parse(localStorage.getItem("TOKEN"))
const timezone = JSON.parse(localStorage.getItem("TIMEZONE"))

axios.defaults.timeout = 30000;
axios.defaults.timeoutErrorMessage='timeout'
if(token){
    axios.defaults.headers.common["x-access-token"] = token;
}
if(timezone){
    axios.defaults.headers.common["timezone"] = timezone?.timezone;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Courses(url = `${process.env.REACT_APP_BASE_URL}/api/`) {
        return {
            getAcourse: (data) => axios.post(url+"courses/getCourseData",data),
            buyAcourse: (data) => axios.post(url+"courses/buyCourse",data)
        }
    }
}